/* eslint-disable unicorn/consistent-function-scoping */
import EntitlementsRoleManagement from '../../services/entitlement-role-management';
import { AppState, AppThunkDispatch } from '..';

export const getEntitlementRolesManagement =
    () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
        const {
            login: { envVariables, client },
        } = getState();

        const service = new EntitlementsRoleManagement(envVariables.entitlementRoleManagementV1BaseUrl, client);
        const response = await service.getEntitlementRoleManagements();
        const { roles } = response.data;
        return roles || [];
    };
